import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Config from '../../commons/config/Config.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import Security from '../../commons/security/Security.js'
import Loading from '../ui/Loading.js'
import {
	Table, TableContainer, TableHead, TableBody, TableRow, Paper,
} from '@material-ui/core'
import { StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles.js'

function ericMediaUrl() {
	return ConfigBusiness.get('eric.inspecciones.general.gatewayUrl') || Config.get('apiUrlBase')
}

function ericMediaHeaders() {
	var token = localStorage.getItem('token')
	// Gateway uses RFC 7235 Bearer; PHP backend uses the legacy Authorization-Token header.
	if (ConfigBusiness.get('eric.inspecciones.general.gatewayUrl')) {
		return { 'Authorization': 'Bearer ' + token }
	}
	return { 'Authorization-Token': token }
}

var BADGE = {
	completed:  { cls: 'badge badge-success',   label: 'Completada' },
	processing: { cls: 'badge badge-warning',   label: 'Procesando' },
	error:      { cls: 'badge badge-danger',    label: 'Fallida'    },
	rejected:   { cls: 'badge badge-secondary', label: 'Rechazada'  },
	incomplete: { cls: 'badge badge-light',     label: 'Incompleta' },
}

var ESTADO_INCR = {
	NUEVO:             { label: 'Nuevo',             color: '#e55353' },
	AGRAVADO:          { label: 'Agravado',           color: '#e67e22' },
	NUEVO_TIPO_DANIO:  { label: 'Nuevo tipo',         color: '#f1c40f' },
	POSIBLE_REPARACION:{ label: 'Posible reparación', color: '#3498db' },
	REPARADO:          { label: 'Reparado',           color: '#27ae60' },
}

var RECHAZABLES = { NUEVO: true, AGRAVADO: true, NUEVO_TIPO_DANIO: true }

var RESOLUCION_LABEL = {
	SIGUE_EXISTIENDO:    'Sigue existiendo',
	FALSO_POSITIVO:      'Falso positivo',
	REPARADO_CON_TICKET: 'Reparado con ticket',
	REPARADO_SIN_TICKET: 'Reparado sin ticket',
}

var ERIC_WARNING_MSG = {
	'eric.warnings.tickets_en_ejecucion': 'Ya existe un ticket abierto en esta inspección.',
}

var TICKET_ESTADO_STYLE = {
	'ABIERTO':   { color: '#2F6DF0', background: 'rgba(47,109,240,0.12)'  },
	'CERRADO':   { color: '#1F9D57', background: 'rgba(31,157,87,0.15)'   },
	'CANCELADO': { color: '#8B909C', background: '#ECEEF2'                 },
}
var TICKET_ESTADO_DEFAULT_STYLE = { color: '#C77A16', background: 'rgba(199,122,22,0.14)' }

function ticketEstadoStyle(estado) {
	return TICKET_ESTADO_STYLE[estado] || TICKET_ESTADO_DEFAULT_STYLE
}

function ticketActivo(d) {
	return d.ticket_id && d.ticket_estado !== 'CERRADO' && d.ticket_estado !== 'CANCELADO'
}

var RESOLUCIONES = [
	{ value: 'REPARADO_CON_TICKET', label: 'Se reparó con un Ticket Correctivo', requiresTicket: true  },
	{ value: 'REPARADO_SIN_TICKET', label: 'Se resolvió sin Ticket Correctivo',  requiresTicket: false },
	{ value: 'SIGUE_EXISTIENDO',    label: 'Sigue existiendo el daño',           requiresTicket: false },
	{ value: 'FALSO_POSITIVO',      label: 'Era suciedad o falso positivo',      requiresTicket: false },
]

var OCR_FIELD_LABEL = { VIN: 'VIN', ODOMETRO: 'Odómetro', PATENTE: 'Patente' }

var ERIC_RECHAZO_LABEL = {
    INCOMPATIBLE_IMAGE:          'Imagen no compatible',
    UNSUPPORTED_FILE_FORMAT:     'Formato de archivo no soportado',
    INCOMPATIBLE_VIDEO:          'Video no compatible',
    IMAGES_AND_VIDEO_IN_BATCH:   'Imágenes y video subidos juntos',
    NO_IMAGE_OR_VIDEO_IN_BATCH:  'No se encontraron imágenes ni video',
    ALL_SIDE_NOT_COVERED:        'No se capturaron todos los lados del vehículo',
    PHOTO_OF_PHOTO:              'Fotografía de una fotografía',
    LOW_LIGHT:                   'Baja luminosidad',
    NON_CAR:                     'No es un vehículo',
    MULTIPLE_CARS:               'Múltiples vehículos en la inspección',
    MULTIPLE_STICKERS:           'Exceso de stickers en el vehículo',
    CAR_INTERIOR:                'Imágenes tomadas desde el interior',
    GARAGE_WORKSHOP_INSPECTION:  'Inspección realizada en taller o garaje',
    LARGE_SIZE_CLAIM:            'Daño severo — requiere inspección manual',
    INSUFFICIENT_COVERAGE:       'Cobertura insuficiente del vehículo',
    ALL_FRAMES_NOT_RECEIVED:     'Carga de fotos incompleta',
    VIN_MANIPULATION:            'Manipulación de número de chasis (VIN)',
    LICENCE_PLATE_MANIPULATION:  'Manipulación de patente',
    IMAGE_MANIPULATION:          'Imágenes alteradas o invertidas',
    BLURRY:                      'Imágenes borrosas',
    MULTIPLE_LOCATIONS:          'Imágenes tomadas en múltiples ubicaciones',
    MUDDY_VEHICLE:               'Vehículo cubierto de barro',
    HIGH_DIRT_OR_SNOW:           'Vehículo con suciedad o nieve',
}

var VEHICULO_TIPO_LABEL = {
    sedan:              'Sedán',
    car_sedan:          'Sedán',
    hatchback:          'Hatchback',
    car_hatchback:      'Hatchback',
    suv:                'SUV',
    car_suv:            'SUV',
    pickup:             'Pickup',
    car_pickup:         'Pickup',
    pickup_truck:       'Pickup',
    car_pickup_truck:   'Pickup',
    minivan:            'Minivan',
    car_minivan:        'Minivan',
    van:                'Furgoneta',
    car_van:            'Furgoneta',
    truck:              'Camión',
    car_truck:          'Camión',
    coupe:              'Coupé',
    car_coupe:          'Coupé',
    convertible:        'Descapotable',
    car_convertible:    'Descapotable',
    wagon:              'Station Wagon',
    car_wagon:          'Station Wagon',
    station_wagon:      'Station Wagon',
    car_station_wagon:  'Station Wagon',
    crossover:          'Crossover',
    car_crossover:      'Crossover',
    mpv:                'Monovolumen',
    car_mpv:            'Monovolumen',
    bus:                'Bus',
    tractor:            'Tractor',
}

var ESTADO_STATUS = {
	PROCESANDO: 'processing',
	COMPLETADA: 'completed',
	RECHAZADA:  'rejected',
	FALLIDA:    'error',
	INCOMPLETA: 'incomplete',
}

// Normalizes PHP flat response into the shape the component renders.
function normalizarInspeccion(d) {
	return {
		id: d.id,
		attributes: {
			status:           ESTADO_STATUS[d.estado] || 'processing',
			report_pdf_url:   d.reporte_pdf_url || null,
			rejection_reason: d.motivo_rechazo || null,
			created_at:       d.created_at || null,
			formulario_id:    d.formulario_id || null,
		},
		flags: {
			plate_discrepancy: !!d.flag_patente_discrepancia,
			vehicle_inactive:  !!d.flag_movil_inactivo,
			form_not_found:    !!d.flag_formulario_no_encontrado,
		},
		columna_extra: d.columna_extra || null,
		vehicle: (d.vehiculo_patente || d.movil_patente || d.vehiculo_marca || d.vehiculo_modelo) ? {
			plate:       d.movil_patente      || null,
			ocr_plate:   d.vehiculo_patente   || null,
			ocr_vin:     d.vehiculo_vin_ocr   || null,
			vin:         d.movil_vin          || null,
			brand:       d.vehiculo_marca     || null,
			model:       d.vehiculo_modelo    || null,
			color:       d.vehiculo_color     || null,
			type:        d.vehiculo_tipo      || null,
			plate_match: !!d.patente_coincide,
			movil_extra: d.movil_extra        || null,
		} : null,
		images: (d.imagenes || []).map(function(img) {
			return { id: img.id, url: img.url, bounding_boxes: img.bounding_boxes || null }
		}),
		damages: (d.danios || []).map(function(dmg) {
			return {
				id:                dmg.id,
				zone:              dmg.zona,
				type:              dmg.tipo_danio,
				severity:          dmg.severidad,
				incremental_status: dmg.estado_incremental,
				resolution:        dmg.resolucion,
				rejected:          !!dmg.rechazado,
				ticket_id:         dmg.ticket_id || null,
				ticket_estado:     dmg.ticket_estado || null,
			}
		}),
		ocr_problems: (d.ocr_problemas || []).map(function(p) {
			return {
				id:                 p.id,
				field:              p.tipo_campo,
				read_value:         p.valor_leido,
				expected_value:     p.valor_esperado,
				reason:             p.motivo,
				reported_incorrect: !!p.reportado_incorrecto,
			}
		}),
	}
}

class EricInspeccionDetalle extends Component {
	constructor(props) {
		super(props)
		this._mounted = false
		this.state = {
			loading:          true,
			inspeccion:       null,
			ocrReportando:    {},
			ocrReportado:     {},
			lightbox:         null,
			danioAccionando:  {}, // { [id]: true } while API call in flight
			danioConfirmando: null, // id of damage awaiting reject confirmation
			// F-10 ticket creation
			ticketModal:     false,
			ticketSeleccion: {}, // { [damageId]: true }
			ticketCreando:   false,
			ticketError:     null,
			ticketCreado:    null, // { ticket_id, warning } persists after modal close
			// F-12 resolution
			resolucionDanioId:  null,   // id of damage currently in resolution flow
			resolucionOpcion:   null,   // selected resolution value
			resolucionTicketId: '',     // ticket ID for REPARADO_CON_TICKET
			resolucionGuardando: false,
			resolucionError:    null,
			pdfDescargando:     false,
		}
		this.reportarOcrProblema = this.reportarOcrProblema.bind(this)
		this.abrirLightbox       = this.abrirLightbox.bind(this)
		this.cerrarLightbox      = this.cerrarLightbox.bind(this)
		this.solicitarRechazo    = this.solicitarRechazo.bind(this)
		this.cancelarRechazo     = this.cancelarRechazo.bind(this)
		this.confirmarRechazo    = this.confirmarRechazo.bind(this)
		this.deshacerRechazo     = this.deshacerRechazo.bind(this)
		this.abrirTicketModal    = this.abrirTicketModal.bind(this)
		this.cerrarTicketModal   = this.cerrarTicketModal.bind(this)
		this.toggleDanioTicket   = this.toggleDanioTicket.bind(this)
		this.crearTicket         = this.crearTicket.bind(this)
		this.abrirResolucion     = this.abrirResolucion.bind(this)
		this.cerrarResolucion    = this.cerrarResolucion.bind(this)
		this.confirmarResolucion = this.confirmarResolucion.bind(this)
	}

	componentWillMount() {
		this._mounted = true
		this.cargar()
	}

	componentWillUnmount() {
		this._mounted = false
	}

	cargar() {
		var component = this
		var id = this.props.match && this.props.match.params && this.props.match.params.id
		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + id, {
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return null
			if (response.status === 404) {
				component.setState({ loading: false })
				return null
			}
			return response.json()
		})
		.then(function(envelope) {
			if (!component._mounted || !envelope) return
			var raw = envelope && envelope.data ? envelope.data : envelope
			component.setState({ inspeccion: normalizarInspeccion(raw), loading: false })
		})
		.catch(function() {
			if (component._mounted) component.setState({ loading: false })
		})
	}

	reportarOcrProblema(inspeccionId, problemaId) {
		var component = this
		var reportando = Object.assign({}, this.state.ocrReportando)
		reportando[problemaId] = true
		this.setState({ ocrReportando: reportando })

		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + inspeccionId + '/ocr-problems/' + problemaId + '/report', {
			method: 'POST',
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return
			var reportando = Object.assign({}, component.state.ocrReportando)
			delete reportando[problemaId]
			if (response.ok) {
				var reportado = Object.assign({}, component.state.ocrReportado)
				reportado[problemaId] = true
				component.setState({ ocrReportando: reportando, ocrReportado: reportado })
			} else {
				component.setState({ ocrReportando: reportando })
			}
		})
		.catch(function() {
			if (!component._mounted) return
			var reportando = Object.assign({}, component.state.ocrReportando)
			delete reportando[problemaId]
			component.setState({ ocrReportando: reportando })
		})
	}

	abrirLightbox(url, boxes) {
		this.setState({ lightbox: { url: url, boxes: boxes || [] } })
	}

	cerrarLightbox() {
		this.setState({ lightbox: null })
	}

	solicitarRechazo(damageId) {
		this.setState({ danioConfirmando: damageId })
	}

	cancelarRechazo() {
		this.setState({ danioConfirmando: null })
	}

	confirmarRechazo(inspeccionId, damageId) {
		var component = this
		var accionando = Object.assign({}, this.state.danioAccionando)
		accionando[damageId] = true
		this.setState({ danioAccionando: accionando, danioConfirmando: null })

		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + inspeccionId + '/damages/' + damageId + '/reject', {
			method: 'POST',
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return
			var accionando = Object.assign({}, component.state.danioAccionando)
			delete accionando[damageId]
			if (response.ok) {
				component.actualizarDanioLocal(damageId, { rejected: true })
			}
			component.setState({ danioAccionando: accionando })
		})
		.catch(function() {
			if (!component._mounted) return
			var accionando = Object.assign({}, component.state.danioAccionando)
			delete accionando[damageId]
			component.setState({ danioAccionando: accionando })
		})
	}

	deshacerRechazo(inspeccionId, damageId) {
		var component = this
		var accionando = Object.assign({}, this.state.danioAccionando)
		accionando[damageId] = true
		this.setState({ danioAccionando: accionando })

		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + inspeccionId + '/damages/' + damageId + '/reject', {
			method: 'DELETE',
			headers: { 'Authorization-Token': localStorage.getItem('token') }
		})
		.then(function(response) {
			if (!component._mounted) return
			var accionando = Object.assign({}, component.state.danioAccionando)
			delete accionando[damageId]
			if (response.ok) {
				component.actualizarDanioLocal(damageId, { rejected: false })
			}
			component.setState({ danioAccionando: accionando })
		})
		.catch(function() {
			if (!component._mounted) return
			var accionando = Object.assign({}, component.state.danioAccionando)
			delete accionando[damageId]
			component.setState({ danioAccionando: accionando })
		})
	}

	actualizarDanioLocal(damageId, campos) {
		var inspeccion = this.state.inspeccion
		if (!inspeccion || !inspeccion.damages) return
		var damages = inspeccion.damages.map(function(d) {
			if (d.id !== damageId) return d
			return Object.assign({}, d, campos)
		})
		this.setState({
			inspeccion: Object.assign({}, inspeccion, { damages: damages })
		})
	}

	abrirTicketModal() {
		var inspeccion = this.state.inspeccion
		var seleccion = {}
		if (inspeccion && inspeccion.damages) {
			inspeccion.damages.forEach(function(d) {
				if (!d.rejected && !ticketActivo(d)) seleccion[d.id] = true
			})
		}
		this.setState({ ticketModal: true, ticketSeleccion: seleccion, ticketError: null })
	}

	cerrarTicketModal() {
		this.setState({ ticketModal: false, ticketError: null })
	}

	toggleDanioTicket(damageId) {
		var sel = Object.assign({}, this.state.ticketSeleccion)
		if (sel[damageId]) {
			delete sel[damageId]
		} else {
			sel[damageId] = true
		}
		this.setState({ ticketSeleccion: sel })
	}

	crearTicket(inspeccionId) {
		var component = this
		var seleccion = this.state.ticketSeleccion
		var damageIds = Object.keys(seleccion)
			.filter(function(k) { return seleccion[k] })
			.map(function(k) { return parseInt(k, 10) })

		if (!damageIds.length) return

		this.setState({ ticketCreando: true, ticketError: null })

		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + inspeccionId + '/tickets', {
			method: 'POST',
			headers: {
				'Authorization-Token': localStorage.getItem('token'),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ damage_ids: damageIds }),
		})
		.then(function(response) {
			if (!component._mounted) return null
			return response.json().then(function(body) {
				return { ok: response.ok, status: response.status, body: body }
			})
		})
		.then(function(result) {
			if (!component._mounted || !result) return
			if (result.ok) {
				var data = result.body && result.body.data ? result.body.data : result.body
				component.setState({
					ticketCreando: false,
					ticketModal:   false,
					ticketCreado:  { ticket_id: data.ticket_id, warning: data.warning || null },
					ticketError:   null,
				})
				damageIds.forEach(function(dmgId) {
					component.actualizarDanioLocal(dmgId, { ticket_id: data.ticket_id, ticket_estado: 'ABIERTO' })
				})
			} else {
				var msg = result.body && result.body.error
					? result.body.error
					: (result.body && result.body.message ? result.body.message : 'Error al crear el ticket.')
				component.setState({ ticketCreando: false, ticketError: msg })
			}
		})
		.catch(function() {
			if (!component._mounted) return
			component.setState({ ticketCreando: false, ticketError: 'Error de conexión al crear el ticket.' })
		})
	}

	abrirResolucion(damageId, currentResolution) {
		this.setState({
			resolucionDanioId:  damageId,
			resolucionOpcion:   currentResolution || null,
			resolucionTicketId: '',
			resolucionGuardando: false,
			resolucionError:    null,
		})
	}

	cerrarResolucion() {
		this.setState({
			resolucionDanioId:  null,
			resolucionOpcion:   null,
			resolucionTicketId: '',
			resolucionGuardando: false,
			resolucionError:    null,
		})
	}

	confirmarResolucion(inspeccionId, damageId) {
		var component = this
		var opcion    = this.state.resolucionOpcion
		var ticketId  = this.state.resolucionTicketId

		if (!opcion) {
			this.setState({ resolucionError: 'Seleccione una opción.' })
			return
		}
		if (opcion === 'REPARADO_CON_TICKET' && !ticketId) {
			this.setState({ resolucionError: 'Ingrese el ID del Ticket Correctivo.' })
			return
		}

		var body = { resolucion: opcion }
		if (opcion === 'REPARADO_CON_TICKET') body.ticket_id = parseInt(ticketId, 10) || 0

		this.setState({ resolucionGuardando: true, resolucionError: null })

		fetch(Config.get('apiUrlBase') + '/v1/inspections/' + inspeccionId + '/damages/' + damageId + '/resolution', {
			method: 'PUT',
			headers: {
				'Authorization-Token': localStorage.getItem('token'),
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		})
		.then(function(response) {
			if (!component._mounted) return null
			return response.json().then(function(b) { return { ok: response.ok, body: b } })
		})
		.then(function(result) {
			if (!component._mounted || !result) return
			if (result.ok) {
				component.actualizarDanioLocal(damageId, { resolution: opcion })
				component.cerrarResolucion()
			} else {
				var msg = result.body && result.body.error
					? result.body.error
					: 'Error al guardar la resolución.'
				component.setState({ resolucionGuardando: false, resolucionError: msg })
			}
		})
		.catch(function() {
			if (!component._mounted) return
			component.setState({ resolucionGuardando: false, resolucionError: 'Error de conexión.' })
		})
	}

	// -------------------------------------------------------------------------

	renderEstadoBadge(status) {
		var entry = BADGE[status]
		if (!entry) return <span className="badge badge-light">{status || '—'}</span>
		return <span className={entry.cls}>{entry.label}</span>
	}

	renderFlags(flags) {
		if (!flags) return null
		var alertas = []
		if (flags.vehicle_inactive)  alertas.push('El vehículo estaba inactivo al momento de la inspección.')
		if (flags.form_not_found)    alertas.push('No se encontró el formulario asociado a esta inspección.')
		if (!alertas.length) return null
		return (
			<div className="mb-3">
				{alertas.map(function(msg, i) {
					return (
						<div key={i} className="alert alert-warning py-2 px-3 mb-1">
							<i className="fa fa-exclamation-triangle mr-1"></i>{msg}
						</div>
					)
				})}
			</div>
		)
	}

	renderVehiculo(vehicle) {
		if (!vehicle) return null
		var campos = [
			{ label: 'Marca',  valor: vehicle.brand },
			{ label: 'Modelo', valor: vehicle.model },
			{ label: 'Color',  valor: vehicle.color },
			{ label: 'Tipo',   valor: vehicle.type ? (VEHICULO_TIPO_LABEL[vehicle.type] || vehicle.type) : null },
		].filter(function(c) { return !!c.valor })
		if (!campos.length) return null
		return (
			<div className="row mb-4">
				{campos.map(function(c, i) {
					return (
						<div key={i} className="col-auto mr-4">
							<small className="text-muted d-block">{c.label}</small>
							<strong>{c.valor}</strong>
						</div>
					)
				})}
			</div>
		)
	}

	renderOcrProblemas(inspeccion) {
		var problemas = inspeccion.ocr_problems || []
		var canReport = Security.hasPermission('ERIC_INSPECTOR_MODIFICAR')
		var component = this
		var id        = inspeccion.id
		var vehicle   = inspeccion.vehicle
		var flags     = inspeccion.flags || {}

		var porCampo = problemas.reduce(function(acc, p) {
			acc[p.field] = p
			return acc
		}, {})

		// PATENTE: vehiculo_patente is always stored from the webhook regardless of match.
		if (!porCampo['PATENTE'] && vehicle && vehicle.ocr_plate) {
			var plateRead     = vehicle.ocr_plate || null
			var plateExpected = vehicle.plate     || null
			porCampo['PATENTE'] = {
				field:          'PATENTE',
				read_value:     plateRead,
				expected_value: plateExpected,
				id:             null,
				discrepant:     !plateRead || !plateExpected
				                    ? flags.plate_discrepancy
				                    : plateRead.toUpperCase().replace(/[-\s]/g, '') !== plateExpected.toUpperCase().replace(/[-\s]/g, ''),
			}
		}

		// VIN: vehiculo_vin_ocr stored by webhook; no ocr_problemas entry means it matched.
		if (!porCampo['VIN'] && vehicle && vehicle.ocr_vin) {
			var vinRead     = vehicle.ocr_vin || null
			var vinExpected = vehicle.vin     || null
			porCampo['VIN'] = {
				field:          'VIN',
				read_value:     vinRead,
				expected_value: vinExpected,
				id:             null,
				discrepant:     !vinRead || !vinExpected
				                    ? false
				                    : vinRead.toUpperCase().replace(/[-\s]/g, '') !== vinExpected.toUpperCase().replace(/[-\s]/g, ''),
			}
		}

		var OCR_FIELDS = ['PATENTE', 'VIN', 'ODOMETRO']

		return (
			<div className="mb-4">
				<h6 className="mb-2">
					<i className="fa fa-file-text-o mr-1"></i>
					Lecturas OCR
				</h6>
				<TableContainer component={Paper} elevation={0} style={{ border: '1px solid #e3ebf3' }}>
					<Table size="small">
						<TableHead>
							<TableRow>
								<StyledTableCell>Campo</StyledTableCell>
								<StyledTableCell>Leído</StyledTableCell>
								<StyledTableCell>Esperado</StyledTableCell>
								<StyledTableCell></StyledTableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{OCR_FIELDS.map(function(field) {
								var p = porCampo[field]
								if (!p) {
									return (
										<TableRow key={field}>
											<StyledTableCell>{OCR_FIELD_LABEL[field] || field}</StyledTableCell>
											<StyledTableCell>—</StyledTableCell>
											<StyledTableCell>—</StyledTableCell>
											<StyledTableCell>
												<i className="fa fa-check text-success"></i>
											</StyledTableCell>
										</TableRow>
									)
								}
								var isDiscrepant = p.discrepant !== undefined ? p.discrepant : true
								var reportable   = !!p.id
								var yaReportado  = reportable && (p.reported_incorrect || !!component.state.ocrReportado[p.id])
								var reportando   = reportable && !!component.state.ocrReportando[p.id]
								return (
									<TableRow key={field}>
										<StyledTableCell>{OCR_FIELD_LABEL[field] || field}</StyledTableCell>
										<StyledTableCell>{p.read_value    || '—'}</StyledTableCell>
										<StyledTableCell>{p.expected_value || '—'}</StyledTableCell>
										<StyledTableCell style={{ whiteSpace: 'nowrap' }}>
											{isDiscrepant ? (
												<span>
													<i className="fa fa-exclamation-triangle text-warning mr-2"></i>
													{canReport && reportable && !yaReportado && (
														<button
															className="btn btn-xs btn-outline-warning"
															disabled={reportando}
															onClick={function() { component.reportarOcrProblema(id, p.id) }}
														>
															{reportando
																? <span><i className="fa fa-spinner fa-spin mr-1"></i>Reportando...</span>
																: 'Reportar lectura incorrecta'
															}
														</button>
													)}
												</span>
											) : (
												<i className="fa fa-check text-success"></i>
											)}
										</StyledTableCell>
									</TableRow>
								)
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		)
	}

	renderBoundingBoxes(boxes) {
		if (!boxes || !boxes.length) return null
		return boxes.map(function(box, i) {
			// Expect normalized 0-1 coords: { x, y, width, height } (top-left origin)
			if (box.x == null || box.y == null || box.width == null || box.height == null) return null
			return (
				<div
					key={i}
					style={{
						position:    'absolute',
						left:        (box.x * 100) + '%',
						top:         (box.y * 100) + '%',
						width:       (box.width * 100) + '%',
						height:      (box.height * 100) + '%',
						border:      '2px solid #e55353',
						boxSizing:   'border-box',
						pointerEvents: 'none',
					}}
				/>
			)
		})
	}

	renderImagenes(inspeccionId, images, status) {
		if (!images || !images.length) {
			if (status === 'processing') {
				return (
					<div className="text-muted small mt-2">
						<i className="fa fa-clock-o mr-1"></i>
						Pendiente — las imágenes estarán disponibles cuando finalice la inspección.
					</div>
				)
			}
			return (
				<div className="mb-4">
					<h6 className="mb-2">
						<i className="fa fa-camera mr-1"></i>
						Imágenes
					</h6>
					<span className="text-muted small">
						<i className="fa fa-image mr-1"></i>
						No se capturaron imágenes en esta inspección.
					</span>
				</div>
			)
		}
		var component = this
		return (
			<div className="mb-4">
				<h6 className="mb-2">
					<i className="fa fa-camera mr-1"></i>
					Imágenes ({images.length})
				</h6>
				<div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
					{images.map(function(img, i) {
						var url = img && img.id
							? ericMediaUrl() + '/v1/inspections/' + inspeccionId + '/images/' + img.id
							: (img && img.url ? img.url : (typeof img === 'string' ? img : null))
						var boxes = img && img.bounding_boxes ? img.bounding_boxes : []
						if (!url) return null
						return (
							<div
								key={i}
								style={{
									position: 'relative',
									width: '160px', height: '120px',
									cursor: 'pointer',
									borderRadius: '4px',
									overflow: 'hidden',
									border: '1px solid #ddd',
									flexShrink: 0,
								}}
								title="Ver imagen completa"
								onClick={function() { component.abrirLightbox(url, boxes) }}
							>
								<img
									src={url}
									alt={'Imagen ' + (i + 1)}
									style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
								/>
								{component.renderBoundingBoxes(boxes)}
								{boxes && boxes.length > 0 && (
									<div
										style={{
											position: 'absolute', bottom: 0, right: 0,
											background: 'rgba(229,83,83,0.85)', color: '#fff',
											fontSize: '0.7rem', padding: '1px 5px',
											borderTopLeftRadius: '4px',
										}}
									>
										{boxes.length} daño{boxes.length !== 1 ? 's' : ''}
									</div>
								)}
							</div>
						)
					})}
				</div>
			</div>
		)
	}

	renderLightbox() {
		var lb = this.state.lightbox
		if (!lb) return null
		var component = this
		return (
			<div
				style={{
					position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
					backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1060,
					display: 'flex', alignItems: 'center', justifyContent: 'center',
				}}
				onClick={this.cerrarLightbox}
			>
				<div
					style={{ position: 'relative', maxWidth: '90vw', maxHeight: '85vh' }}
					onClick={function(e) { e.stopPropagation() }}
				>
					<div style={{ position: 'relative', display: 'inline-block' }}>
						<img
							src={lb.url}
							alt="Inspección"
							style={{ maxWidth: '90vw', maxHeight: '80vh', display: 'block' }}
						/>
						{component.renderBoundingBoxes(lb.boxes)}
					</div>
					<button
						onClick={this.cerrarLightbox}
						style={{
							position: 'absolute', top: '-12px', right: '-12px',
							background: '#fff', border: 'none', borderRadius: '50%',
							width: '28px', height: '28px', cursor: 'pointer',
							fontWeight: 'bold', fontSize: '1rem', lineHeight: '28px',
							textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.4)',
						}}
					>×</button>
				</div>
			</div>
		)
	}

	renderResolucionPanel(inspeccionId, damageId) {
		var component   = this
		var opcion      = this.state.resolucionOpcion
		var guardando   = this.state.resolucionGuardando
		var error       = this.state.resolucionError
		var colCount    = Security.hasPermission('ERIC_INSPECTOR_MODIFICAR') ? 6 : 5

		return (
			<TableRow key={'resolucion-' + damageId}>
				<StyledTableCell colSpan={colCount} style={{ background: '#f8f9ff', padding: '12px 16px' }}>
					<div style={{ maxWidth: '480px' }}>
						<div className="mb-2" style={{ fontWeight: 500, fontSize: '0.875rem' }}>
							<i className="fa fa-check-circle mr-1 text-primary"></i>
							Confirmar resolución del daño
						</div>

						{RESOLUCIONES.map(function(r) {
							var isSelected = opcion === r.value
							return (
								<div key={r.value} className="mb-1">
									<label style={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-start', gap: '6px', margin: 0 }}>
										<input
											type="radio"
											name={'resolucion-' + damageId}
											value={r.value}
											checked={isSelected}
											disabled={guardando}
											onChange={function() {
												component.setState({ resolucionOpcion: r.value, resolucionTicketId: '', resolucionError: null })
											}}
											style={{ marginTop: '3px', flexShrink: 0 }}
										/>
										<span style={{ fontSize: '0.875rem' }}>{r.label}</span>
									</label>
									{isSelected && r.requiresTicket && (
										<div className="ml-3 mt-1 pl-2" style={{ borderLeft: '2px solid #007bff' }}>
											<label style={{ fontSize: '0.8rem', marginBottom: '3px', display: 'block' }}>
												ID del Ticket Correctivo en VEC Fleet
											</label>
											<input
												type="number"
												min="1"
												className="form-control form-control-sm"
												style={{ width: '160px' }}
												placeholder="Ej. 1234"
												value={component.state.resolucionTicketId}
												disabled={guardando}
												onChange={function(e) {
													component.setState({ resolucionTicketId: e.target.value, resolucionError: null })
												}}
											/>
										</div>
									)}
								</div>
							)
						})}

						{error && (
							<div className="mt-2" style={{ color: '#dc3545', fontSize: '0.8rem' }}>
								<i className="fa fa-exclamation-circle mr-1"></i>{error}
							</div>
						)}

						<div className="mt-3 d-flex" style={{ gap: '6px' }}>
							<button
								className="btn btn-sm btn-primary"
								disabled={!opcion || guardando}
								onClick={function() { component.confirmarResolucion(inspeccionId, damageId) }}
							>
								{guardando
									? <span><i className="fa fa-spinner fa-spin mr-1"></i>Guardando...</span>
									: 'Guardar'
								}
							</button>
							<button
								className="btn btn-sm btn-outline-secondary"
								disabled={guardando}
								onClick={component.cerrarResolucion}
							>
								Cancelar
							</button>
						</div>
					</div>
				</StyledTableCell>
			</TableRow>
		)
	}

	renderDanios(inspeccion) {
		var damages = inspeccion.damages
		var status  = inspeccion.attributes && inspeccion.attributes.status
		if (!damages || !damages.length) {
			if (status === 'processing') {
				return (
					<div className="text-muted small mt-2">
						<i className="fa fa-clock-o mr-1"></i>
						Pendiente — los daños se cargarán cuando Eric IA complete el análisis.
					</div>
				)
			}
			return null
		}

		var canModify    = Security.hasPermission('ERIC_INSPECTOR_MODIFICAR')
		var component    = this
		var inspeccionId = inspeccion.id

		return (
			<div className="mb-4">
				<h6 className="mb-2">
					<i className="fa fa-warning mr-1 text-danger"></i>
					Daños detectados ({damages.length})
				</h6>
				<TableContainer component={Paper} elevation={0} style={{ border: '1px solid #e3ebf3' }}>
					<Table size="small">
						<TableHead>
							<TableRow>
								<StyledTableCell>Zona</StyledTableCell>
								<StyledTableCell>Tipo de daño</StyledTableCell>
								<StyledTableCell>Severidad</StyledTableCell>
								<StyledTableCell>Estado incremental</StyledTableCell>
								<StyledTableCell>Ticket</StyledTableCell>
								<StyledTableCell>Resolución</StyledTableCell>
								{canModify && <StyledTableCell style={{ width: '150px' }}></StyledTableCell>}
							</TableRow>
						</TableHead>
						<TableBody>
							{damages.map(function(d) {
							var estadoInfo     = ESTADO_INCR[d.incremental_status] || null
							var accionando     = !!component.state.danioAccionando[d.id]
							var confirmando    = component.state.danioConfirmando === d.id
							var rechazable     = !!RECHAZABLES[d.incremental_status]
							var posibleRep     = d.incremental_status === 'POSIBLE_REPARACION'
							var enResolucion   = component.state.resolucionDanioId === d.id

							return (
								<React.Fragment key={d.id}>
								<TableRow style={{ opacity: d.rejected ? 0.55 : 1 }}>
									<StyledTableCell>{d.zone || '—'}</StyledTableCell>
									<StyledTableCell>
										<span style={{ textDecoration: d.rejected ? 'line-through' : 'none' }}>
											{d.type || '—'}
										</span>
										{d.rejected && (
											<span className="ml-1 badge badge-warning" style={{ fontSize: '0.7rem' }}>
												<i className="fa fa-times mr-1"></i>Rechazado
											</span>
										)}
									</StyledTableCell>
									<StyledTableCell>
										{d.severity != null ? (
											<span title={d.severity}>
												{renderSeverityBar(parseFloat(d.severity))}
											</span>
										) : '—'}
									</StyledTableCell>
									<StyledTableCell>
										{estadoInfo ? (
											<span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
												<span style={{
													display: 'inline-block',
													width: '9px', height: '9px',
													borderRadius: '50%',
													background: estadoInfo.color,
													flexShrink: 0,
												}} />
												{estadoInfo.label}
											</span>
										) : (d.incremental_status || '—')}
									</StyledTableCell>
									<StyledTableCell>
										{d.ticket_id ? (
											<span style={{ whiteSpace: 'nowrap' }}>
												<Link to={'/tickets/' + d.ticket_id} style={{ color: 'inherit', marginRight: '5px' }}>
													#{d.ticket_id}
												</Link>
												{d.ticket_estado && (
													<span style={{
														padding: '2px 6px',
														borderRadius: '4px',
														fontSize: '0.72em',
														fontWeight: 600,
														color: ticketEstadoStyle(d.ticket_estado).color,
														background: ticketEstadoStyle(d.ticket_estado).background,
													}}>
														{d.ticket_estado.replace(/_/g, ' ')}
													</span>
												)}
											</span>
										) : '—'}
									</StyledTableCell>
									<StyledTableCell>
										{RESOLUCION_LABEL[d.resolution] || d.resolution || (
											<span className="text-muted">Sin asignar</span>
										)}
									</StyledTableCell>
									{canModify && (
										<StyledTableCell style={{ whiteSpace: 'nowrap' }}>
											{accionando ? (
												<span className="text-muted" style={{ fontSize: '0.8rem' }}>
													<i className="fa fa-spinner fa-spin mr-1"></i>
												</span>
											) : confirmando ? (
												<span style={{ display: 'inline-flex', gap: '4px', alignItems: 'center' }}>
													<small className="text-danger mr-1">¿Confirmar?</small>
													<button
														className="btn btn-xs btn-danger"
														onClick={function() { component.confirmarRechazo(inspeccionId, d.id) }}
													>Sí</button>
													<button
														className="btn btn-xs btn-outline-secondary"
														onClick={component.cancelarRechazo}
													>No</button>
												</span>
											) : enResolucion ? (
												<button
													className="btn btn-xs btn-outline-secondary"
													onClick={component.cerrarResolucion}
												>
													<i className="fa fa-times mr-1"></i>Cancelar
												</button>
											) : d.rejected ? (
												<button
													className="btn btn-xs btn-outline-secondary"
													title="Deshacer rechazo"
													onClick={function() { component.deshacerRechazo(inspeccionId, d.id) }}
												>
													<i className="fa fa-undo mr-1"></i>Deshacer
												</button>
											) : rechazable ? (
												<button
													className="btn btn-xs btn-outline-danger"
													title="Rechazar este daño"
													onClick={function() { component.solicitarRechazo(d.id) }}
												>
													<i className="fa fa-times mr-1"></i>Rechazar
												</button>
											) : posibleRep ? (
												<button
													className="btn btn-xs btn-outline-primary"
													title="Confirmar resolución"
													onClick={function() { component.abrirResolucion(d.id, d.resolution) }}
												>
													<i className="fa fa-check mr-1"></i>
													{d.resolution ? 'Cambiar' : 'Resolver'}
												</button>
											) : null}
										</StyledTableCell>
									)}
								</TableRow>
								{enResolucion && component.renderResolucionPanel(inspeccionId, d.id)}
								</React.Fragment>
							)
						})}
						</TableBody>
					</Table>
				</TableContainer>
			</div>
		)
	}

	renderTicketModal(inspeccion) {
		if (!this.state.ticketModal) return null
		var component    = this
		var inspeccionId = inspeccion.id
		var damages      = inspeccion.damages || []
		var elegibles      = damages.filter(function(d) { return !d.rejected })
		var seleccionables = elegibles.filter(function(d) { return !ticketActivo(d) })
		var seleccion      = this.state.ticketSeleccion
		var countSel       = Object.keys(seleccion).filter(function(k) { return seleccion[k] }).length
		var allSelected    = seleccionables.length > 0 && countSel === seleccionables.length

		return (
			<div
				style={{
					position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
					backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070,
					display: 'flex', alignItems: 'center', justifyContent: 'center',
				}}
				onClick={this.cerrarTicketModal}
			>
				<div
					style={{
						background: '#fff', borderRadius: '6px', padding: '24px',
						width: '500px', maxWidth: '95vw', maxHeight: '80vh',
						display: 'flex', flexDirection: 'column',
					}}
					onClick={function(e) { e.stopPropagation() }}
				>
					<div style={{ marginBottom: '16px' }}>
						<h5 style={{ margin: 0 }}>
							<i className="fa fa-wrench mr-2 text-warning"></i>
							Generar Ticket Correctivo
						</h5>
						<small className="text-muted">Chapa y Pintura — Inspección #{inspeccionId}</small>
					</div>

					{this.state.ticketError && (
						<div className="alert alert-danger py-2 px-3 mb-3" style={{ fontSize: '0.875rem' }}>
							<i className="fa fa-times-circle mr-1"></i>{this.state.ticketError}
						</div>
					)}

					{elegibles.length === 0 ? (
						<div className="alert alert-warning py-2 px-3 mb-3" style={{ fontSize: '0.875rem' }}>
							No hay daños disponibles para incluir en el ticket.
						</div>
					) : (
						<div style={{ overflowY: 'auto', flex: 1, marginBottom: '16px' }}>
							<div className="d-flex align-items-center mb-2" style={{ fontSize: '0.85rem' }}>
								<span className="text-muted mr-2">Daños a incluir:</span>
								<button
									className="btn btn-xs btn-link p-0"
									onClick={function() {
										var sel = {}
										if (!allSelected) {
											seleccionables.forEach(function(d) { sel[d.id] = true })
										}
										component.setState({ ticketSeleccion: sel })
									}}
								>
									{allSelected ? 'Deseleccionar todo' : 'Seleccionar todo'}
								</button>
							</div>
							<table className="table table-sm table-hover mb-0" style={{ fontSize: '0.875rem' }}>
								<tbody>
									{elegibles.map(function(d) {
										var checked  = !!seleccion[d.id]
										var bloqueado = ticketActivo(d)
										if (bloqueado) {
											return (
												<tr key={d.id} style={{ opacity: 0.6 }}>
													<td style={{ width: '36px' }}></td>
													<td>{d.zone || '—'}</td>
													<td>{d.type || '—'}</td>
													<td style={{ color: '#888', fontSize: '0.8rem' }}>
														{ESTADO_INCR[d.incremental_status]
															? ESTADO_INCR[d.incremental_status].label
															: (d.incremental_status || '—')}
													</td>
													<td style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
														<Link to={'/tickets/' + d.ticket_id} style={{ color: 'inherit' }}>
															#{d.ticket_id}
														</Link>
														{d.ticket_estado && (
															<span style={{
																marginLeft: '4px',
																padding: '1px 5px',
																borderRadius: '4px',
																fontSize: '0.72em',
																fontWeight: 600,
																color: ticketEstadoStyle(d.ticket_estado).color,
																background: ticketEstadoStyle(d.ticket_estado).background,
															}}>
																{d.ticket_estado.replace(/_/g, ' ')}
															</span>
														)}
													</td>
												</tr>
											)
										}
										return (
											<tr
												key={d.id}
												style={{ cursor: 'pointer' }}
												onClick={function() { component.toggleDanioTicket(d.id) }}
											>
												<td style={{ width: '36px' }}>
													<input
														type="checkbox"
														checked={checked}
														onChange={function() { component.toggleDanioTicket(d.id) }}
														onClick={function(e) { e.stopPropagation() }}
													/>
												</td>
												<td>{d.zone || '—'}</td>
												<td>{d.type || '—'}</td>
												<td style={{ color: '#888', fontSize: '0.8rem' }}>
													{ESTADO_INCR[d.incremental_status]
														? ESTADO_INCR[d.incremental_status].label
														: (d.incremental_status || '—')}
												</td>
												<td></td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)}

					<div className="d-flex justify-content-end" style={{ gap: '8px' }}>
						<button
							className="btn btn-sm btn-outline-secondary"
							disabled={this.state.ticketCreando}
							onClick={this.cerrarTicketModal}
						>
							Cancelar
						</button>
						<button
							className="btn btn-sm btn-warning"
							disabled={countSel === 0 || this.state.ticketCreando}
							onClick={function() { component.crearTicket(inspeccionId) }}
						>
							{this.state.ticketCreando ? (
								<span><i className="fa fa-spinner fa-spin mr-1"></i>Creando...</span>
							) : (
								<span><i className="fa fa-wrench mr-1"></i>Crear ticket ({countSel})</span>
							)}
						</button>
					</div>
				</div>
			</div>
		)
	}

	renderTicketCreado() {
		var tc = this.state.ticketCreado
		if (!tc) return null
		return (
			<div className="alert alert-success py-2 px-3 mb-3 d-flex align-items-center justify-content-between"
				style={{ fontSize: '0.875rem' }}>
				<span>
					<i className="fa fa-check-circle mr-1"></i>
					<strong>Ticket #{tc.ticket_id}</strong> generado exitosamente.
					{' '}
					<Link to={'/tickets/' + tc.ticket_id} style={{ color: 'inherit', textDecoration: 'underline' }}>
						Ver ticket
					</Link>
				</span>
				{tc.warning && (
					<span className="ml-3 text-warning" style={{ fontSize: '0.8rem' }}>
						<i className="fa fa-exclamation-triangle mr-1"></i>
						{ERIC_WARNING_MSG[tc.warning] || tc.warning}
					</span>
				)}
			</div>
		)
	}

	render() {
		if (this.state.loading) {
			return (
				<div className="content-body">
					<div className="text-center py-5"><Loading /></div>
				</div>
			)
		}

		var inspeccion = this.state.inspeccion
		var backUrl    = this.props.match
			? this.props.match.url.replace(/\/[^/]+$/, '')
			: '/eric'

		if (!inspeccion) {
			return (
				<div className="content-body">
					<div className="alert alert-warning">Inspección no encontrada.</div>
					<Link to={backUrl} className="btn btn-sm btn-outline-secondary">
						<i className="fa fa-arrow-left mr-1"></i>Volver
					</Link>
				</div>
			)
		}

		var component    = this
		var attrs        = inspeccion.attributes || {}
		var status       = attrs.status
		var hasReport    = !!(attrs.has_report || attrs.report_pdf_url)
		var pdfDescargando = this.state.pdfDescargando
		var damages      = inspeccion.damages || []
		var elegiblesParaTicket = damages.filter(function(d) { return !d.rejected && !ticketActivo(d) })
		var canTicket = Security.hasPermission('ERIC_INSPECTOR_CREAR_TICKET')
			&& status === 'completed'
			&& elegiblesParaTicket.length > 0

		return (
			<div className="content-body">
				{this.renderLightbox()}
				{this.renderTicketModal(inspeccion)}

				<div className="content-header row mb-3">
					<div className="content-header-left col-12">
						<div className="d-flex align-items-center justify-content-between mb-1">
						<div className="d-flex align-items-center">
							<Link to={backUrl} className="btn btn-sm btn-outline-secondary mr-3">
								<i className="fa fa-arrow-left mr-1"></i>Volver
							</Link>
							<span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
								<i className="fa fa-camera mr-1"></i>
								Inspección #{inspeccion.id}
							</span>
							<span className="ml-2">{this.renderEstadoBadge(status)}</span>
							{attrs.created_at && (
								<small className="text-muted ml-3">
									{attrs.created_at.substring(0, 16).replace('T', ' ')}
								</small>
							)}
						</div>
						<div className="d-flex align-items-center" style={{ gap: '8px' }}>
							{attrs.formulario_id && (
								<Link
									to={'/formulario/' + attrs.formulario_id}
									className="btn btn-sm btn-outline-secondary"
								>
									<i className="fa fa-list-alt mr-1"></i>Ver formulario
								</Link>
							)}
							{canTicket && (
								<button
									className="btn btn-sm btn-warning"
									onClick={this.abrirTicketModal}
								>
									<i className="fa fa-wrench mr-1"></i>Generar ticket correctivo
								</button>
							)}
							{hasReport && (
								<button
									className="btn btn-sm btn-outline-danger"
									disabled={pdfDescargando}
									onClick={function() {
										var id = inspeccion.id
										component.setState({ pdfDescargando: true })
										fetch(ericMediaUrl() + '/v1/inspections/' + id + '/report', {
											headers: ericMediaHeaders()
										})
											.then(function(res) {
												if (!res.ok) throw new Error('proxy_failed')
												return res.blob()
											})
											.then(function(blob) {
												component.setState({ pdfDescargando: false })
												var url = URL.createObjectURL(blob)
												var a = document.createElement('a')
												a.href = url
												a.download = 'reporte-' + id + '.pdf'
												a.click()
												URL.revokeObjectURL(url)
											})
											.catch(function() {
												component.setState({ pdfDescargando: false })
												alert('No se pudo descargar el reporte PDF.')
											})
									}}
								>
									{pdfDescargando
										? <span><i className="fa fa-spinner fa-spin mr-1"></i>Descargando...</span>
										: <span><i className="fa fa-file-pdf-o mr-1"></i>Descargar PDF</span>
									}
								</button>
							)}
						</div>
					</div>
					<div className="d-flex align-items-baseline mt-1">
						<span style={{ fontSize: '1.6rem', fontWeight: 700, letterSpacing: '0.05em' }}>
							{inspeccion.columna_extra && inspeccion.vehicle && inspeccion.vehicle.movil_extra ? (
								<span>
									{inspeccion.columna_extra.label}:{' '}
									{inspeccion.vehicle.movil_extra}
									<span style={{ margin: '0 8px' }}>—</span>
									{inspeccion.vehicle.plate ? inspeccion.vehicle.plate.toUpperCase() : '—'}
								</span>
							) : (
								inspeccion.vehicle && inspeccion.vehicle.plate
									? inspeccion.vehicle.plate.toUpperCase()
									: '—'
							)}
						</span>
					</div>
				</div>
			</div>

				<div className="card">
					<div className="card-content">
						<div className="card-body">
							{status === 'processing' && (
								<div className="text-muted mb-3 d-flex align-items-center">
									<i className="fa fa-spinner fa-spin mr-2"></i>
									<span>Inspección en proceso — los resultados estarán disponibles en breve.</span>
									<button
										className="btn btn-sm btn-outline-secondary ml-3"
										onClick={() => this.cargar()}
									>
										<i className="fa fa-refresh mr-1"></i>Recargar
									</button>
								</div>
							)}
							{status === 'error' && (
								<div className="alert alert-danger py-2 mb-3">
									<i className="fa fa-times-circle mr-1"></i>
									No fue posible procesar la inspección.
								</div>
							)}
							{status === 'rejected' && (
								<div className="alert alert-secondary py-2 mb-3">
									<i className="fa fa-ban mr-1"></i>
									<strong>Inspección rechazada por Eric IA.</strong>
									{attrs.rejection_reason && (
										<span className="ml-2">
											Motivo: {ERIC_RECHAZO_LABEL[attrs.rejection_reason] || attrs.rejection_reason}
										</span>
									)}
								</div>
							)}

							{this.renderFlags(inspeccion.flags)}
							{this.renderVehiculo(inspeccion.vehicle)}
							{this.renderOcrProblemas(inspeccion)}
							{this.renderImagenes(inspeccion.id, inspeccion.images, status)}
							{this.renderTicketCreado()}
							{this.renderDanios(inspeccion)}

							{status === 'completed'
							 && (!inspeccion.images  || !inspeccion.images.length)
							 && (!inspeccion.damages || !inspeccion.damages.length) && (
								<div className="text-muted">
									<i className="fa fa-check-circle mr-1 text-success"></i>
									Inspección completada sin daños detectados.
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

// Renders a small horizontal bar representing severity 0-1
function renderSeverityBar(value) {
	if (isNaN(value)) return '—'
	var pct  = Math.round(Math.min(1, Math.max(0, value)) * 100)
	var color = pct >= 70 ? '#e55353' : pct >= 40 ? '#f39c12' : '#27ae60'
	return (
		<span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
			<span style={{
				display: 'inline-block', width: '60px', height: '8px',
				background: '#e9ecef', borderRadius: '4px', overflow: 'hidden',
			}}>
				<span style={{
					display: 'block', width: pct + '%', height: '100%',
					background: color, borderRadius: '4px',
				}} />
			</span>
			<span style={{ fontSize: '0.8rem', color: '#666' }}>{pct}%</span>
		</span>
	)
}

export default EricInspeccionDetalle
